import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Search } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const norm = (c) => String(c || "").replace(/\s+/g, "").toLowerCase();

export default function AdminWlePartners({ token }) {
  const [companies, setCompanies] = useState(null);
  const [certs, setCerts] = useState([]);
  const [busy, setBusy] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    fetch(`${API}/hof/companies-public`).then((r) => r.json()).then((d) => setCompanies(d.companies || [])).catch(() => setCompanies([]));
    axios.get(`${API}/hof/wle-partners`).then(({ data }) => setCerts(data.certs || [])).catch(() => {});
  }, []);

  const on = (c) => certs.some((x) => norm(x) === norm(c.certificate_no));
  const toggle = async (c) => {
    const next = on(c) ? certs.filter((x) => norm(x) !== norm(c.certificate_no)) : [...certs, c.certificate_no];
    setBusy(c.certificate_no);
    try {
      const { data } = await axios.put(`${API}/admin/wle-partners`, { certs: next }, { headers: { Authorization: `Bearer ${token}` } });
      setCerts(data.certs || []);
    } catch (e) { alert(e?.response?.data?.detail || "Uloženie zlyhalo."); }
    finally { setBusy(""); }
  };

  const list = (companies || []).filter((c) => !q.trim() || `${c.name} ${c.certificate_no}`.toLowerCase().includes(q.trim().toLowerCase()));

  return (
    <div data-testid="admin-wle-partners" className="mt-12 border border-[#D4AF37]/30 bg-gradient-to-b from-[#0d0d0c] to-[#080808] p-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 justify-between mb-5">
        <div className="flex items-center gap-4">
          <span className="seal-shine relative w-14 h-14 shrink-0 rounded-full overflow-hidden ring-1 ring-[#D4AF37]/50">
            <img src="/wle-partner-seal.webp?v=2" alt="Pečať Work, learn and earn©" className="w-full h-full object-cover" />
          </span>
          <div>
            <h3 className="font-display text-xl text-white">Pečať Work, learn and earn©</h3>
            <p className="text-white/45 text-sm">Zapnite pri firme — pečať sa hneď zobrazí v Sieni slávy. ({certs.length} firiem)</p>
          </div>
        </div>
        <div className="relative sm:w-64">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/35" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Hľadať firmu…" data-testid="wle-search"
            className="w-full bg-black border border-white/15 pl-8 pr-3 py-2 text-sm text-white focus:border-[#D4AF37] outline-none" />
        </div>
      </div>
      {companies === null ? (
        <p className="text-white/40 text-sm flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Načítavam firmy zo Siene slávy…</p>
      ) : (
        <div className="divide-y divide-white/5">
          {list.map((c) => (
            <div key={c.certificate_no} className="flex items-center justify-between gap-4 py-3" data-testid={`wle-row-${norm(c.certificate_no)}`}>
              <div className="min-w-0">
                <p className="text-white truncate">{c.name}</p>
                <p className="text-[#D4AF37]/80 text-xs font-mono">{c.certificate_no}</p>
              </div>
              <button type="button" role="switch" aria-checked={on(c)} onClick={() => toggle(c)} disabled={busy === c.certificate_no}
                data-testid={`wle-toggle-${norm(c.certificate_no)}`}
                className={`relative w-12 h-6 shrink-0 rounded-full transition-colors duration-300 disabled:opacity-50 ${on(c) ? "bg-[#D4AF37]" : "bg-white/15"}`}>
                <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform duration-300 ${on(c) ? "translate-x-6" : ""}`} />
              </button>
            </div>
          ))}
          {list.length === 0 && <p className="text-white/40 text-sm py-3">Žiadna firma.</p>}
        </div>
      )}
    </div>
  );
}
